<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <title>Email</title>
    <path
      d="M2.5 7.16699L9.0755 11.5507C9.63533 11.9239 10.3647 11.9239 10.9245 11.5507L17.5 7.16699M4.16667 16.3337H15.8333C16.7538 16.3337 17.5 15.5875 17.5 14.667V6.33366C17.5 5.41318 16.7538 4.66699 15.8333 4.66699H4.16667C3.24619 4.66699 2.5 5.41318 2.5 6.33366V14.667C2.5 15.5875 3.24619 16.3337 4.16667 16.3337Z"
      stroke="#00787C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
